export class Party {
  constructor(public company_name?: string,
              public company_legal_id?: string,
              public company_tax_id?: string) {
  }
}
